<template>
  <!-- Vue Router 的進入點 -->
  <router-view />
</template>

<script setup>
// 不需要 Layout、Navbar、Sidebar，這些在 AdminLayout 裡面已經有
</script>

<style>
body {
  margin: 0;
  font-family: "Microsoft JhengHei", Arial, sans-serif;
  background-color: #f5f7fa;
}
</style>
